export default __webpack_public_path__ + "static/media/pokezon_recording_2.c5ffb33d.mp4";